import { minifyGraphQL } from '@/lib/helper/minifyGraphql';

export const cropMediaFragment = minifyGraphQL(`
                    media {
                      url
                      type
                      mimeType
                      playlistJson
                      thumbnailUrl
                      thumbnailURL
                      originalUrl
                      width
                      height
                    }
                    cropDetails {
                     optimizedUrl
                     type
                     url
                    }
`);
